/**
 * Converts a weekday number to day name (1=Sunday, 2=Monday, ..., 7=Saturday)
 */
export const getDayNameFromWeekdayNumber = (
  dayNumber: WeekdayType['day'],
): WeekdayType['weekDay'] | null => {
  const dayNames = ['', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return dayNames[dayNumber] as WeekdayType['weekDay'] | null;
};

export type WeekdayType = {
  day: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  weekDay: 'Sunday' | 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday';
};
